import { createContext, useState, useMemo } from 'react';

type CertMasterPlatformLinkAccountContextType = {
  isLinking: boolean;
  setIsLinking: (isLinking: boolean) => void;
};

export const CertMasterPlatformLinkAccountContext = createContext<
  CertMasterPlatformLinkAccountContextType | undefined
>(undefined);

export function CertMasterPlatformLinkAccountProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isLinking, setIsLinking] = useState(false);

  const value = useMemo(
    () => ({
      isLinking,
      setIsLinking,
    }),
    [isLinking],
  );

  return (
    <CertMasterPlatformLinkAccountContext.Provider value={value}>
      {children}
    </CertMasterPlatformLinkAccountContext.Provider>
  );
}
